module.exports = __webpack_public_path__ + "releases/667f16e80d22650c96d928d5f1364500352df6a6/img/curvinha-fill.af9739c4.svg";